import React from 'react';

import styled from 'styled-components';

const CompletionSummary = styled.div`
  font-size: 16px;
  color: var(--text-primary);
  display: flex;
  align-items: baseline;
  gap: 2px;
`;

const CompletionCount = styled.span`
  font-size: 40px;
  font-family: var(--font-bold);
  line-height: 1;
`;

const CompletionTotal = styled.span`
  font-family: var(--font-bold);
`;

const ProgressTrack = styled.div`
  width: 400px;
  height: 5px;
  margin-top: 5px;
  margin-bottom: 20px;
  border-radius: 4px;
  background-color: #d7d7d7;
  overflow: hidden;
`;

const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => `${progress}%`};
  border-radius: 4px;
  background-image: linear-gradient(to right, #17dcae, #0ab776);
`;

type Props = {
  completedItemsCount: number;
  totalItemsCount: number;
  completionProgress: number;
};

const ActionPlanDetailsProgress = ({ completedItemsCount, totalItemsCount, completionProgress }: Props) => {
  return (
    <>
      <CompletionSummary data-test-id="action-plan-details-completion-summary">
        <CompletionCount data-test-id="action-plan-details-completion-count">{completedItemsCount}</CompletionCount>
        <CompletionTotal data-test-id="action-plan-details-completion-total">/{totalItemsCount}</CompletionTotal>
        <span data-test-id="action-plan-details-completion-label"> action items complete</span>
      </CompletionSummary>
      <ProgressTrack data-test-id="action-plan-details-progress-track">
        <ProgressFill progress={completionProgress} />
      </ProgressTrack>
    </>
  );
};

export default ActionPlanDetailsProgress;
